module.exports = __webpack_public_path__ + "img/img-related03.054fa0d6.jpg";